import transformer from '@/services/gabed/collectivite/collectiviteServerTableDataTransformer';
import HTTP from '../HTTP';

const URL_BASE = 'commun/CollectiviteAvecDeclarationTlpe/';

// eslint-disable-next-line import/prefer-default-export
export async function getAll(serverTabledata) {
  const inputServer = transformer(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}
